import { makeStyles } from "tss-react/mui"
import { getCategoryColors } from "../../../../mp-core/themes/categoryColors"
import { chipClasses } from "@mui/material"

type StylesParams = {
  category?: string
}

export const useStyles = makeStyles<StylesParams>()(
  ({ palette }, { category = "" }) => ({
    root: {
      backgroundColor: getCategoryColors(category)?.primary,
      color: palette.common.white,

      [`& .${chipClasses.label} .material-icons`]: {
        color: palette.common.white
      }
    }
  })
)
